import axios from "axios";
import type { GetServerSidePropsContext, InferGetServerSidePropsType } from "next";

import { BreadCrumb } from "@/components/BreadCrumb";
import type {
    GetCategoryAreaDto,
    GetCategoryDto,
} from "@/entities/types/entities";
import { PageLayout } from "@/layouts/PageLayout";
import { Routes } from "@/shared/constants";
import { API_BASE } from "@/shared/constants/private";
import { filterByStatus } from "@/shared/utils/filterAndSort/getSortDirection";
import { LiftMedia } from "@/view/LiftMedia";

export default function LiftMediaPage({
    id,
    cat,
    area,
    slug,
}: InferGetServerSidePropsType<typeof getServerSideProps>) {
    const filter = cat.filter((el) => el.id === id)[0];
    const items = [{ label: "Реклама в торговых центрах", url: Routes.POSTERTC }, { label: filter.title }];

    return (
        <PageLayout title={filter.seoTitle} description={filter.seoDescription} page_type="service">
            <BreadCrumb model={items} />
            <LiftMedia
                url={`${Routes.POSTERTC}/${slug}`}
                urlGeneral={`${Routes.POSTERTC}`}
                data={filter}
                districts={filterByStatus(area)}
            />
        </PageLayout>
    );
}

export const getServerSideProps = async (ctx: GetServerSidePropsContext) => {
    const { slug } = ctx.params as { slug: string };

    try {
        const resCat = await axios.get<GetCategoryDto[]>(`${API_BASE}/category`,{
            params: { onlyPublished: true },
        });
        const category = resCat.data.find((el) => el?.urlTitle === slug);

        if (!category) return { notFound: true };

        const { id } = category;

        const resArea = await axios.get<GetCategoryAreaDto[]>(`${API_BASE}/category-area`, { params: { categoryId: id } }).catch(() => ({ data: [] }))

        return {
            props: {
                id,
                slug,
                cat: resCat.data,
                area: resArea.data,
            },
        };
    } catch (error) {
        return { notFound: true };
    }
};
